import { render, staticRenderFns } from "./participatesItem.vue?vue&type=template&id=202072e5&scoped=true"
import script from "./participatesItem.vue?vue&type=script&lang=js"
export * from "./participatesItem.vue?vue&type=script&lang=js"
import style0 from "./participatesItem.vue?vue&type=style&index=0&id=202072e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202072e5",
  null
  
)

export default component.exports